import React from 'react'
import { Container } from "react-bootstrap";
import Particle from '../components/Particle';
import ContactForm from '../components/Contact/Contact';
import Social from '../components/Contact/Social';
import Chatbot from '../components/Chatbot';
import PageTransition from '../components/PageTransition';

const Contact = () => {
  return (
    <PageTransition>
      <Container style={{ padding: '80px 20px 60px 20px', minHeight: '100vh' }}>
        <Particle />
        <ContactForm />
        <Social />
        <Chatbot />
      </Container>
    </PageTransition>
  )
}

export default Contact
